import React from "react";
import Sidebar from "@/components/Sidebar";
import Player from "@/components/Player";

export default function Layout({ children }) {
  return (
    <div data-testid="app-shell" className="min-h-screen bg-[var(--voix-bg)] text-[var(--voix-text)] relative">
      <div className="flex">
        <Sidebar />
        <main className="flex-1 min-w-0 pb-40">{children}</main>
      </div>
      <Player />
    </div>
  );
}
